

import React, { useEffect, useState, useMemo } from "react";
import { useAuth } from "../App";
import { toast } from "sonner";
import Layout from "../components/Layout";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { useParams } from "react-router-dom";


function formatDuration(minutesFloat) {
  if (minutesFloat == null || isNaN(minutesFloat)) return "—";
  const totalMinutes = Math.round(minutesFloat);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${h}h ${m}m`;
}

export default function UserPayrolls() {
  const { userId } = useParams();  // Récupère userId depuis la route
  const { axiosInstance, user } = useAuth();  
  const [prestations, setPrestations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());

  const TARGET_ETAB_ID = "19036569-8d87-48c0-a886-36def8770f49";

  useEffect(() => {
    fetchPrestations();
  }, []);

  // const fetchPrestations = async () => {
  //   try {
  //     const res = await axiosInstance.get("/prestations/me");
  //     setPrestations(res.data);
  //   } catch {
  //     toast.error("Erreur lors du chargement des prestations");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchPrestations = async () => {
    try {
      // Si admin et userId défini, charger prestations de l’autre utilisateur
      if (userId && user.role === 'admin') {
        const res = await axiosInstance.get(`/prestations/user/${userId}`);
        setPrestations(res.data);
      } else {
        const res = await axiosInstance.get("/prestations/me");
        setPrestations(res.data);
      }
    } catch {
      toast.error("Erreur lors du chargement des prestations");
    } finally {
      setLoading(false);
    }
  };
  const filteredPrestations = useMemo(() => {
    return prestations.filter(p => {
      const dt = new Date(p.dateStart);
      const monthMatch = selectedMonth ? (dt.getMonth() + 1).toString().padStart(2, "0") === selectedMonth : true;
      const yearMatch = selectedYear ? dt.getFullYear().toString() === selectedYear : true;
      return monthMatch && yearMatch;
    });
  }, [prestations, selectedMonth, selectedYear]);


  // const calculateTotals = () => {
  //   const gross = filteredPrestations.reduce((acc, p) => {
  //     return acc + (p.gain_final ?? p.final_rate ?? 0);
  //   }, 0);

  //   const isNurse = user?.role === "nurse";
  //   // const rate = isNurse ? 0.09 : 0.07;
  //   const rate = user?.role === "nurse" ? 0.09 : 0.07;

  //   const discount = gross * rate;
  //   const net = gross - discount;

  //   return { gross, discount, net, rate };
  // };


  const calculateTotals = () => {
    const gross = filteredPrestations.reduce((acc, p) => {
      return acc + (p.gain_final ?? p.final_rate ?? 0);
    }, 0);

    const rate = user?.role === "nurse" ? 0.09 : 0.07;

    const discount = gross * rate;
    const net = gross - discount;

    return { gross, discount, net, rate };
  };

  const analyzeHours = () => {
    let totalPrev = 0, weekPrev = 0, weekendPrev = 0;
    let totalReal = 0, weekReal = 0, weekendReal = 0;

    filteredPrestations.forEach(p => {
      const dt = new Date(p.dateStart);
      const day = dt.getDay();
      const planned = p.dureeMinutes || 0;
      const actual = Math.round(p.actual_duration || 0);
      totalPrev += planned;
      totalReal += actual;
      if (day === 0 || day === 6) {
        weekendPrev += planned;
        weekendReal += actual;
      } else {
        weekPrev += planned;
        weekReal += actual;
      }
    });

    return {
      totalHoursPlanned: (totalPrev / 60).toFixed(2),
      weekHoursPlanned: (weekPrev / 60).toFixed(2),
      weekendHoursPlanned: (weekendPrev / 60).toFixed(2),
      totalHoursReal: (totalReal / 60).toFixed(2),
      weekHoursReal: (weekReal / 60).toFixed(2),
      weekendHoursReal: (weekendReal / 60).toFixed(2),
    };
  };

  
  const getPrestationDetails = (p) => {
  const dureePayee = p.dureeMinutes || 0;
  const actualDuration = p.actual_duration || 0;
  const isTargetEtab = p.etablissement_id === TARGET_ETAB_ID;
  const isCompleted = p.status === "completed";

  // ✅ DURÉE BRUTE = payée + pause (9h30m pour affichage)
  const dureeBrute = isTargetEtab ? dureePayee + 30 : dureePayee;
  
  // Durée facturée = réelle ou prévue
  let dureeFinal = p.actual_duration_payee || actualDuration || dureePayee;
  
  // Pause pour affichage
  let pauseDeduite = p.pause_non_payee_minutes || 0;
  if (isTargetEtab && p.pause_non_payee_appliquee) {
    pauseDeduite = 30;
  }

  console.log("Prestation complète:", p);

  return { 
    dureeInitiale: dureeBrute,  // 570min
    dureeBrute,                 // 570min  
    dureeFinal,                 // 540min
    pauseDeduite,               // 30min
    isTargetEtab, 
    isCompleted 
  };
};

  // const targetEtabName = prestations.find(
  //   p => p.etablissement_id === TARGET_ETAB_ID
  // )?.etablissement_name;
  const targetEtabName =
    prestations.find(
      p => String(p.etablissement_id) === String(TARGET_ETAB_ID)
    )?.etablissement_name || "la charmille";



    const exportPdf = () => {
      if (filteredPrestations.length === 0) {
        toast.error("Aucune prestation pour ce mois et cette année");
        return;
      }

      const doc = new jsPDF("portrait", "pt", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();
      const logo = new Image();
      logo.src = "/sanacare.jpg";

      logo.onload = () => {
        doc.addImage(logo, "JPEG", 40, 30, 90, 45);

        doc.setFont("Helvetica", "bold");
        doc.setFontSize(16);
        doc.text("SANA-CARE DIAMOND", pageWidth - 40, 50, { align: "right" });

        doc.setFontSize(10);
        doc.setFont("Helvetica", "normal");
        doc.text("Avenue louise 200, 1050 Bruxelles", pageWidth - 40, 65, { align: "right" });
        doc.text("Sana-carediamond@outlook.com", pageWidth - 40, 80, { align: "right" });
        doc.text("1025.941.977", pageWidth - 40, 95, { align: "right" });
        doc.text("BE71 3632 5061 2169", pageWidth - 40, 110, { align: "right" });

        doc.setLineWidth(1);
        doc.line(40, 125, pageWidth - 40, 125);

        doc.setFont("Helvetica", "bold");
        doc.setFontSize(20);
        doc.text(`FICHE DE PAIE - ${selectedMonth || 'Tous les mois'}/${selectedYear}`, pageWidth / 2, 165, { align: "center" });

        doc.setFontSize(12);
        doc.setFont("Helvetica", "bold");
        doc.text("SOIGNANT :", 40, 205);
        doc.setFontSize(11);
        doc.setFont("Helvetica", "normal");
        doc.text(`Nom : ${user?.first_name || "—"}`, 40, 225);
        doc.text(`Email : ${user?.email || "—"}`, 40, 240);
        doc.text(`Téléphone : ${user?.phone || "—"}`, 40, 255);
        doc.text(`Adresse : ${user?.address || "—"}`, 40, 270);

        doc.setLineWidth(0.8);
        doc.line(40, 290, pageWidth - 40, 290);

        const columns = ["Début", "Fin", "Description", "Durée brute", "Pause déduite", "Durée facturée", "Montant (€)", "Statut"];

        const rows = filteredPrestations.map((p) => {
          const { dureeInitiale, dureeFinal, pauseDeduite, isTargetEtab, isCompleted } = getPrestationDetails(p);
          return [
            new Date(p.dateStart).toLocaleDateString(),
            new Date(p.dateEnd).toLocaleDateString(),
            p.description || "—",
            formatDuration(dureeInitiale),
            (pauseDeduite > 0 || (isTargetEtab && isCompleted))
              ? `- ${formatDuration(pauseDeduite > 0 ? pauseDeduite : 30)}`
              : "—",
            isCompleted && dureeFinal != null ? formatDuration(dureeFinal) : "—",
            // isCompleted ? Number(p.gain_final ?? 0).toFixed(2) : "—",
            isCompleted ? Number(p.gain_final ?? p.final_rate ?? 0).toFixed(2)  : "—",
            
            p.status || "—",
          ];
        });

        autoTable(doc, {
          startY: 310,
          head: [columns],
          body: rows,
          styles: { fontSize: 9, cellPadding: 5 },
          headStyles: {
            fillColor: [230, 180, 40],
            textColor: 20,
            fontSize: 10,
            halign: "center"
          },
          margin: { left: 40, right: 40 }
        });

        // const totals = calculateTotals();
        const totals = calculateTotals();
        const isNurse = user?.role === "nurse";
        // const rate = isNurse ? 9 : 7;
        const finalY = doc.lastAutoTable.finalY + 30;

        doc.setFont("Helvetica", "italic");
        doc.setFontSize(9);
        doc.text(
          `* Pause de 30 min déduite UNIQUEMENT pour les prestations effectuées dans ${
            targetEtabName ? `l’établissement « ${targetEtabName} »` : `l’établissement ID ${TARGET_ETAB_ID}`
          } (accord spécifique)`,
          40,
          finalY
        );


        doc.setFont("Helvetica", "bold");
        doc.setFontSize(14);
        doc.text(`TOTAL BRUT : ${totals.gross.toFixed(2)} €`, pageWidth - 40, finalY + 20, { align: "right" });
        doc.setFont("Helvetica", "normal");
        // doc.text(`Prélèvement (7 %) : -${totals.discount.toFixed(2)} €`, pageWidth - 40, finalY + 40, { align: "right" });
        // doc.text(`Prélèvement (${rate} %) : -${totals.discount.toFixed(2)} €`, pageWidth - 40, finalY + 40, { align: "right" });
        doc.text(
            `Prélèvement (${(totals.rate * 100).toFixed(0)} %) : -${totals.discount.toFixed(2)} €`,
            pageWidth - 40,
            finalY + 40,
            { align: "right" }
          );
        doc.setFont("Helvetica", "bold");
        doc.text(`TOTAL NET : ${totals.net.toFixed(2)} €`, pageWidth - 40, finalY + 60, { align: "right" });

        doc.save("fiche_de_paie.pdf");
      };
    };

    if (loading) return <div>Chargement...</div>;

    const totals = calculateTotals();
    const hours = analyzeHours();

    return (
      <Layout title="Fiche de paie détaillée">
        <div className="flex items-center justify-between mb-4">
          <div className="flex space-x-2">
            <Select onValueChange={setSelectedMonth}>
              <SelectTrigger className="w-[150px] bg-white">
                <SelectValue placeholder="Mois" />
              </SelectTrigger>
              <SelectContent>
                {Array.from({ length: 12 }).map((_, i) => {
                  const value = (i + 1).toString().padStart(2, "0");
                  return (
                    <SelectItem key={value} value={value}>
                      {new Date(0, i).toLocaleString('fr-FR', { month: 'long' })}
                    </SelectItem>
                  );
                })}
              </SelectContent>
            </Select>

            <Select onValueChange={setSelectedYear}>
              <SelectTrigger className="w-[100px] bg-white">
                <SelectValue placeholder="Année" />
              </SelectTrigger>
              <SelectContent>
                {Array.from({ length: 5 }, (_, i) => (2023 + i).toString()).map(year => (
                  <SelectItem key={year} value={year}>{year}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <button 
            onClick={exportPdf} 
            className="px-4 py-2 bg-amber-600 text-white rounded hover:bg-amber-700"
          >
            Exporter en PDF
          </button>
        </div>

        <h1 className="text-2xl font-bold mb-4 text-amber-900">Mes prestations</h1>

        <div className="mb-4 p-3 bg-amber-50 border border-amber-300 rounded text-sm text-gray-700">
          <p>
            <b>📋 Info importante :</b> Une pause de 30 minutes non rémunérée est automatiquement déduite{' '}
            <b>UNIQUEMENT</b> pour les prestations effectuées dans l'établissement{' '}
            <span className="font-bold text-amber-700">
              {prestations.find(p => p.etablissement_id === TARGET_ETAB_ID)?.etablissement_name || "spécifique"}
            </span>{' '}
            (accord interne).
          </p>

        </div>

        <table className="w-full text-sm border border-gray-300 mb-6">
          <thead className="bg-yellow-300">
            <tr>
              <th className="border p-2">Date début</th>
              <th className="border p-2">Date fin</th>
              <th className="border p-2">Description</th>
              <th className="border p-2">Durée brute</th>
              <th className="border p-2">Pause déduite</th>
              <th className="border p-2">Durée facturée</th>
              <th className="border p-2">Montant (€)</th>
              <th className="border p-2">Statut</th>
            </tr>
          </thead>
          <tbody>
            {filteredPrestations.map((p) => {
              const { dureeInitiale, dureeFinal, pauseDeduite, isTargetEtab, isCompleted } = getPrestationDetails(p);

              return (
                <tr key={p._id} className="hover:bg-yellow-50">
                  <td className="border px-2 py-1">{new Date(p.dateStart).toLocaleDateString()}</td>
                  <td className="border px-2 py-1">{new Date(p.dateEnd).toLocaleDateString()}</td>
                  <td className="border px-2 py-1">{p.description || "—"}</td>
                  {/* <td className="border px-2 py-1">{formatDuration(dureeInitiale)}</td> */}
                  {/* <td className="border px-2 py-1">{formatDuration(dureeBrute)}</td> */}
                  <td className="border px-2 py-1">{formatDuration(dureeInitiale)}</td>

                  <td className="border px-2 py-1 text-orange-600 font-semibold">
                    {(pauseDeduite > 0 || (isTargetEtab && isCompleted)) 
                      ? `- ${formatDuration(pauseDeduite > 0 ? pauseDeduite : 30)}`
                      : "—"}
                  </td>
                  <td className="border px-2 py-1 font-semibold">
                    {isCompleted && dureeFinal != null ? formatDuration(dureeFinal) : "—"}
                  </td>
                  <td className="border px-2 py-1 font-semibold text-right">
                    {/* {isCompleted ? `${Number(p.gain_final ?? 0).toFixed(2)} €` : "—"} */}
                    {isCompleted ? `${Number(p.gain_final ?? p.final_rate ?? 0).toFixed(2)} €` : "—"}
                  </td>
                  <td className={`border px-2 py-1 text-center text-sm ${
                    p.status === "completed" ? "text-green-600" : 
                    p.status === "in_progress" ? "text-blue-600" : 
                    p.status === "assigned" ? "text-amber-600" : 
                    p.status === "accepted" ? "text-emerald-700" : "text-gray-500"
                  }`}>
                    {p.status || "—"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="bg-amber-50 border border-amber-300 rounded-md p-4 shadow">
          <h2 className="text-lg font-semibold text-amber-900 mb-2">Récapitulatif mensuel</h2>
          <h3 className="font-semibold text-gray-700 mt-2 mb-1">Prévisionnel :</h3>
          <p>Heures totales prévues : <b>{hours.totalHoursPlanned} h</b></p>
          <p>&nbsp;&nbsp;Semaine : <b>{hours.weekHoursPlanned} h</b>&nbsp;&nbsp;|&nbsp;&nbsp;Week-end : <b>{hours.weekendHoursPlanned} h</b></p>
          <h3 className="font-semibold text-gray-700 mt-3 mb-1">Effectif :</h3>
          <p>Heures totales prestées : <b>{hours.totalHoursReal} h</b></p>
          <p>&nbsp;&nbsp;Semaine : <b>{hours.weekHoursReal} h</b>&nbsp;&nbsp;|&nbsp;&nbsp;Week-end : <b>{hours.weekendHoursReal} h</b></p>
          <hr className="my-3" />
          <p>Total estimé (brut) : <b>{totals.gross.toFixed(2)} €</b></p>
          {/* <p>Prélèvement (7 %) : <b>-{totals.discount.toFixed(2)} €</b></p>
           */}
           <p>
              Prélèvement ({(totals.rate * 100).toFixed(0)} %) :{" "}
              <b>-{totals.discount.toFixed(2)} €</b>
            </p>
          <p className="text-amber-700">Total après remise (net) : <b>{totals.net.toFixed(2)} €</b></p>
        </div>
      </Layout>
    );
  }
